import { yupResolver } from '@hookform/resolvers/yup';
import React, { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { View } from 'react-native';
import { Footer, Input, Text } from '~/components';

import * as yup from 'yup';
import { isEmail } from '~/utils/yup';
import { useCreateAccountForm } from '~/stores';
import type { CreateAccuntStepsProps } from '../..';

interface StepFormData {
  email: string;
}

export const schema = yup
  .object()
  .shape({
    email: isEmail(),
  })
  .required();

const EmailPage: React.FC<CreateAccuntStepsProps> = ({ onContinue }) => {
  const { setEmail } = useCreateAccountForm();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<StepFormData>({
    resolver: yupResolver(schema),
  });

  const onSubmit = useCallback(
    ({ email }: StepFormData) => {
      setEmail(email);
      onContinue?.();
    },
    [onContinue, setEmail]
  );

  return (
    <View className="justify-between lg:w-[450px]">
      <Text className="text-[22px] text-center text-gray-700 mt-6 mb-14">
        Criar conta de acesso
      </Text>

      <View className="mb-10">
        <Input
          control={control}
          name="email"
          label="Email"
          placeholder="E-mail"
          keyboardType="email-address"
          error={errors.email?.message}
          autoCapitalize="none"
          maxLength={100}
        />
      </View>

      <Footer
        noPadding
        onSubmit={handleSubmit(onSubmit)}
        buttonLabel="Próximo"
      />
    </View>
  );
};

export default EmailPage;
